export default __webpack_public_path__ + "63910243c00fd0d1abd22751f12b6320.png";